"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Swapper = void 0;
const dexs_1 = require("./dexs");
class Swapper {
    constructor(network, web3Provider, augustus) {
        this.network = network;
        this.web3Provider = web3Provider;
        this.augustus = augustus;
    }
    buildExchangeData(dataObject) {
        const calldata = dataObject.calldata;
        let concatenatedCallData = '0x';
        let startIndex = [0];
        for (let i = 0; i < calldata.length; i++) {
            const tempCalldata = calldata[i].substring(2);
            const index = tempCalldata.length / 2;
            startIndex.push(startIndex[i] + index);
            concatenatedCallData = concatenatedCallData.concat(tempCalldata);
        }
        return {
            callees: dataObject.callees,
            values: dataObject.values,
            calldata: concatenatedCallData,
            startIndexes: startIndex,
        };
    }
    appendToDataObject(dataObject, dexData) {
        dataObject.callees = dataObject.callees.concat(dexData.callees);
        dataObject.calldata = dataObject.calldata.concat(dexData.calldata);
        dataObject.values = dataObject.values.concat(dexData.values);
        return dataObject;
    }
    buildSwap(srcToken, destToken, srcAmount, minDestinationAmount, exchangeData) {
        return __awaiter(this, void 0, void 0, function* () {
            //TODO: add data validation
            let dataObject = {
                callees: [],
                calldata: [],
                values: [],
            };
            for (let i = 0; i < exchangeData.length; i++) {
                const Dex = dexs_1.getDEX(exchangeData[i].name.toLowerCase());
                if (Dex) {
                    const dexData = yield new Dex(this.network, this.web3Provider, this.augustus).buildSwap(srcToken, destToken, exchangeData[i]);
                    dataObject = this.appendToDataObject(dataObject, dexData);
                }
                else {
                    throw new Error('Unsupported Exchange: ' + exchangeData[i].name);
                }
            }
            const returnData = this.buildExchangeData(dataObject);
            if (!returnData) {
                throw new Error('Operation failed!!');
            }
            return Object.assign(Object.assign({}, returnData), { srcToken,
                destToken,
                srcAmount,
                minDestinationAmount });
        });
    }
}
exports.Swapper = Swapper;
//# sourceMappingURL=swapper.js.map